import { APP_NAME } from "../configs/api";
import { cn } from "../helpers/Common";

export const DEFAULT_TABLE_THEME = cn(
  "table-header-regular relative  hover:text-gray-500 hover:transition-all hover:duration-300 hover:ease-in-out",
  APP_NAME === "semai-kebun" && "hover:bg-[rgba(124,7,17,0.2)]"
);
